import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import uitoolkit from "@zoom/videosdk-ui-toolkit";
import "@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css";
import { LeaveScreen } from "../VideoSDK/components/screen/LeaveScreen";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import animationData from "../VideoSDK/animations/join_meeting.json";

function ZoomVideoCall() {
  const location = useLocation();
  const [isLeft, setIsLeft] = useState(false);
  const { userName, } = useSelector((state) => state.channel);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const dataParam = queryParams.get("data");

    if (!dataParam) return;

    const callCreatedData = JSON.parse(decodeURIComponent(dataParam));
    const sessionContainer = document.getElementById("sessionContainer");

    const config = {
      videoSDKJWT: callCreatedData.token,
      sessionName: callCreatedData.roomId,
      userName: userName || "Guest",
      featuresOptions: {
        feedback: { enable: false },
        preview: { enable: false },
        virtualBackground: {
          enable: true,
          virtualBackgrounds: [
            {
              url: "https://images.unsplash.com/photo-1715490187538-30a365fa05bd?q=80&w=1945&auto=format&fit=crop",
            },
          ],
        },
        header: { enable: false },
        troubleshoot: { enable: false },
        invite: { enable: false },
      },
    };

    let sessionActive = false;

    if (sessionContainer) {
      uitoolkit.joinSession(sessionContainer, config);
      sessionActive = true;

      uitoolkit.on("connection-change", (payload) => {
        if (!payload || !payload.state) return;

        const { state, reason = "Unknown" } = payload;

        if (state === "Connected") {
          setTimeout(() => {
            setIsLoading(false);
          }, 4000);
        }

        if (state === "Closed") {
          if (["HostEndedSession", "KickedFromSession", "Unknown"].includes(reason)) {
            setIsLeft(true);
            setIsLoading(false);
            window.history.replaceState(null, null, `/call/call_ended`);
          }
        }

        if (state === "Fail") {
          setIsLeft(true);
          setIsLoading(false);
          window.history.replaceState(null, null, `/call/call_ended`);
        }
      });

      uitoolkit.onSessionClosed(() => {
        sessionActive = false;
        setIsLeft(true);
        setIsLoading(false);
        window.history.replaceState(null, null, `/call/call_ended`);
      });
    }

    const handleBeforeUnload = (e) => {
      if (sessionActive) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    const handleUnload = () => {
      if (sessionActive) {
        uitoolkit.leaveSession();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
      if (sessionActive) {
        uitoolkit.leaveSession();
      }
    };
  }, [location, userName]);

  return (
    <>
      {!isLeft ? (
        <div style={{ position: "relative" }}>
          <main>
            <div id="sessionContainer" />
          </main>

          {isLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                fontSize: "1.5rem",
                zIndex: 9999,
              }}
            >
              <div className="flex flex-col items-center">
                <Lottie
                  animationData={animationData}
                  loop={true}
                  autoplay={true}
                  style={{ height: 200, width: 200 }}
                />
                <p>
                  Joining Session
                </p>
                <p className="text-sm">Please wait while we set up your connection...</p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <LeaveScreen />
      )}
    </>
  );


}


export default ZoomVideoCall;
